import React from 'react';
import { NavLink } from 'react-router-dom';

const DocumentsCrumb = () => <NavLink to="/admin/documents">Documents</NavLink>;

export default DocumentsCrumb;
